import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import confetti from 'canvas-confetti';
import './GoldPerformer.css';

const API = process.env.REACT_APP_BACKEND_URL;

const GOLD = ['#FFD700', '#FFC300', '#FFEA70', '#F5B71E', '#FFF3B0', '#96C11F'];

export default function GoldPerformer({ member, onClose }) {
  const canvasRef = useRef(null);
  const timers = useRef([]);

  useEffect(() => {
    const shooter = confetti.create(canvasRef.current, { resize: true, useWorker: true });

    const firework = () => {
      const x = 0.15 + Math.random() * 0.7;
      const y = 0.15 + Math.random() * 0.45;
      shooter({
        particleCount: 90,
        startVelocity: 28,
        spread: 360,
        ticks: 70,
        gravity: 0.9,
        origin: { x, y },
        colors: Math.random() > 0.4 ? GOLD : undefined,
        scalar: 0.9 + Math.random() * 0.6,
      });
    };

    // opening double cannon
    shooter({ particleCount: 160, angle: 60, spread: 70, origin: { x: 0, y: 0.9 }, colors: GOLD, startVelocity: 55 });
    shooter({ particleCount: 160, angle: 120, spread: 70, origin: { x: 1, y: 0.9 }, colors: GOLD, startVelocity: 55 });

    // fireworks barrage
    for (let i = 0; i < 14; i++) {
      timers.current.push(setTimeout(firework, 350 + i * 380));
    }
    // slow gold rain
    const rain = setInterval(() => {
      shooter({ particleCount: 6, angle: 90, spread: 100, origin: { x: Math.random(), y: -0.05 }, colors: GOLD, gravity: 0.55, startVelocity: 12, ticks: 220, scalar: 0.8 });
    }, 180);
    timers.current.push(rain);

    const autoClose = setTimeout(onClose, 8000);
    timers.current.push(autoClose);

    return () => {
      timers.current.forEach((t) => { clearTimeout(t); clearInterval(t); });
      shooter.reset();
    };
  }, [onClose]);

  return createPortal(
    <div className="gp-overlay" onClick={onClose} data-testid="gold-performer">
      <canvas ref={canvasRef} className="gp-canvas" />
      <div className="gp-stage">
        <div className="gp-rays" />
        <div className="gp-photo-wrap">
          <div className="gp-photo">
            <img src={`${API}${member.photo}`} alt={member.name} />
          </div>
          <div className="gp-ring" />
          <div className="gp-ring gp-ring-2" />
        </div>
        <p className="gp-sub">{member.name} · AI Lunatic!</p>
        <p className="gp-hint">tap anywhere to dismiss</p>
      </div>
    </div>,
    document.body
  );
}
